import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.paintingGroups.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getGroupsData = createSelector(
  (state) => state.paintingGroups.data.paintingGroups,
  (groups = []) => groups
);
const getCurrencyData = createSelector(
  (state) => state.paintingGroups.data.currency,
  (currency = {}) => currency
);

export default {
  getCurrencyData,
  getGroupsData,
  getHasLoaded,
};
